import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestBiztripsGetRes } from "./abst/DtoRequestBiztripsGetRes";

export class DtoRequestBiztripsGetResImple extends DtoRequestBiztripsGetRes {
  public request = new EntityRequest();
  
  public pager = new DtoApiPager();
}
